// src/helper-functions/livestock/utils/format-patcher.js

export function normalizeAnimals(animals, detail) {
    try {
        if (!animals || !Array.isArray(animals) || animals.length === 0) return []
        return animals.map(animal => {
            try {
                const mergedDetail = animal.id.includes('*') ? { ...animal.detail, ...detail } : animal.detail
                return { ...animal, detail: { ...mergedDetail } }
            } catch (err) {
                console.error('normalizeAnimals', err)
                return animal
            }
        })
    } catch (err) {
        console.error('normalizeAnimals', err)
        return []
    }
}

export function normalizeSummary(summary) {
    if (!summary) return {}
    try {
        if (getRootType(summary) === 'wrapped') {
            let newSummary = {}
            const keys = Object.keys(summary)
            for (const key of keys) {
                newSummary[key] = rebucketBirthsToBandMax(summary[key])
            }
            return newSummary
        }
        return rebucketBirthsToBandMax(summary)
    } catch (err) {
        console.error('normalizeAnimals', err)
        return []
    }
}

function getRootType(obj) {
    const keys = Object.keys(obj)
    if (!keys.length) return 'empty'
    // if the first key is numeric-like
    if (!isNaN(Number(keys[0]))) return 'wrapped'
    return 'direct'
}

const speciesAgeClassRanges = { cattle: { calves: { min: 0, max: 182 }, weaners: { min: 183, max: 365 } }, sheep: { lambs: { min: 0, max: 98 }, weaners: { min: 99, max: 365 }, hoggets: { min: 366, max: 730 }, mutton: { min: 731, max: 1825 } } }

const defaultBirths = sp => {
    const bands = Object.values(speciesAgeClassRanges[sp.toLowerCase()] || {})
    const keys = [...new Set(bands.map(b => b.max).filter(Number.isFinite))].sort((a, b) => a - b)
    const o = Object.fromEntries(keys.map(k => [k, 0]))
    o.older = 0
    return o
}

export const rebucketBirthsToBandMax = (lsSum = {}) => {
    try {
        const out = {}
        for (const [sp, data] of Object.entries(lsSum)) {
            const bands = Object.values(speciesAgeClassRanges[sp.toLowerCase()] || {})
            const edges = [...new Set(bands.flatMap(b => [b.min, b.max].filter(Number.isFinite)))].sort((a, b) => a - b)

            const births = { ...defaultBirths(sp) }
            for (const [k, n] of Object.entries(data.births || {})) {
                if (k === 'older') {
                    births.older += n
                    continue
                }
                const age = +k
                const band = bands.find(b => age >= (b.min ?? -Infinity) && age <= (b.max ?? Infinity))
                let key
                if (band && Number.isFinite(band.max)) key = band.max
                else {
                    // snap to nearest finite edge (tie → higher)
                    key = edges.reduce((best, e) => {
                        const d = Math.abs(e - age),
                            bd = Math.abs(best - age)
                        return d < bd || (d === bd && e > best) ? e : best
                    }, edges[0] ?? age)
                }
                births[key] = (births[key] || 0) + n
            }
            out[sp] = { ...data, births }
        }
        return out
    } catch (err) {
        console.error('rebucketBirthsToBandMax', err)
        return {}
    }
}
